import * as types from './types';

export const resetState = () => ({
  type: types.CANDIDATE_APPLICATION_DOCUMENTS_RESET_STATE
});

export const setFormLoading = (isFormLoading) => ({
  type: types.CANDIDATE_APPLICATION_DOCUMENTS_SET_FORM_LOADING,
  isFormLoading
});

export const setCandidateApplicationDocuments = (documents) => ({
  type: types.CANDIDATE_APPLICATION_DOCUMENTS_SET_SUMMARIES,
  documents
});

export const getCandidateApplicationDocuments = (applicationId) => ({
  type: types.CANDIDATE_APPLICATION_DOCUMENTS_GET_SUMMARIES,
  applicationId
});

export const deleteCandidateApplicationDocument = (applicationId, documentId) => ({
  type: types.CANDIDATE_APPLICATION_DOCUMENTS_DELETE_DOCUMENT,
  applicationId,
  documentId
});

export const updateCandidateApplicationDocument = (applicationId, documentId, document) => ({
  type: types.CANDIDATE_APPLICATION_DOCUMENTS_UPDATE_DOCUMENT,
  applicationId,
  documentId,
  document
});

export const addCandidateApplicationDocument = (applicationId, virtualDocumentId, document) => ({
  type: types.CANDIDATE_APPLICATION_DOCUMENTS_ADD_DOCUMENT,
  applicationId,
  virtualDocumentId,
  document
});

export const setNewCandidateApplicationDocument = (candidateApplicationDocument) => ({
  type: types.CANDIDATE_APPLICATION_DOCUMENTS_SET_NEW_DOCUMENT,
  candidateApplicationDocument
});

export const setDocumentAdding = (isDocumentAdding) => ({
  type: types.CANDIDATE_APPLICATION_DOCUMENTS_SET_DOCUMENT_ADDING,
  isDocumentAdding
});

export const setDocumentRemoving = (isDocumentRemoving) => ({
  type: types.CANDIDATE_APPLICATION_DOCUMENTS_SET_DOCUMENT_REMOVING,
  isDocumentRemoving
});

export const setDocumentUpdating = (isDocumentUpdating) => ({
  type: types.CANDIDATE_APPLICATION_DOCUMENTS_SET_DOCUMENT_UPDATING,
  isDocumentUpdating
});


// WEBPACK FOOTER //
// ./src/actions/candidate/candidate-application-documents/index.js